import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

const regexUDYAM = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;

export const isValidUDYAMNumber = (UDYAMNumber) => {
  if (
    isNull(UDYAMNumber) ||
    isUndefined(UDYAMNumber) ||
    incorrectDataType(UDYAMNumber, 'string') ||
    hasWhitespacesOnly(UDYAMNumber) ||
    isEmpty(UDYAMNumber)
  ) {
    return false;
  } else {
    return regexUDYAM.test(UDYAMNumber);
  }
};
